import FieldDefs from './VisdomainFieldDefs'
import {doLangFields} from '../../lib/ks-tools'

export default {
    template: `<div><slot v-bind="self"/></div>`,
    data() {
        return {
            fields: doLangFields(this, "lang.report.visdomain", FieldDefs),
            moreParams: {},
        }
    },
    computed: {
        self() {
            return this;
        },
    },
}
